export const formatPhoneNumber = (value: string): string => {
    const phoneNumber = value.replace(/\D/g, '');

    const trimmed = phoneNumber.slice(0, 10);

    if (trimmed.length === 0) return '';
    if (trimmed.length <= 3) return `(${trimmed}`;
    if (trimmed.length <= 6) return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3)}`;
    return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
}; 